import {anyPass, isEmpty, isUndefined} from '@logistics-frontend/utils'

export const isEmptyOrUndefined: (value?: string) => boolean = anyPass([isUndefined, isEmpty])
